import type { IHttpClient } from '@wix/yoshi-flow-editor';
import type { HttpResponse, RequestOptionsFactory } from '@wix/http-client';

const cacheKeyGenerator = (request: object): string => {
  return JSON.stringify(request);
};

const cacheContext: { cache?: Map<string, unknown> } = {};

export const withCacheResponse = async <R extends object, T>({
  httpClient,
  fn,
  request,
}: {
  httpClient: IHttpClient;
  fn: (request: R) => RequestOptionsFactory<T>;
  request: R;
}): Promise<HttpResponse<T>> => {
  const cacheKey = cacheKeyGenerator(request);

  if (!cacheContext.cache) {
    cacheContext.cache = new Map();
  }

  if (!cacheContext.cache.has(cacheKey)) {
    const response = await httpClient.request<T>(fn(request));
    cacheContext.cache.set(cacheKey, response);
  }

  return cacheContext.cache.get(cacheKey) as HttpResponse<T>;
};
